export const GooglePlayStoreLogo = ({ className, onClick }) => {
  return (
    <svg
      id="artwork"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 238.96 70.87"
      className={className}
    >
      <defs>
        <style>
          {
            "\n      .st0 {\n        fill: #4285f4;\n      }\n\n      .st1 {\n        fill: #a6a6a6;\n      }\n\n      .st2 {\n        fill: #34a853;\n      }\n\n      .st3 {\n        fill: #fbbc04;\n      }\n\n      .st4 {\n        fill: #fff;\n      }\n\n      .st5 {\n        fill: #ea4335;\n      }\n    "
          }
        </style>
      </defs>
      <g>
        <rect x={-0.11} y={0} width={239.17} height={70.87} rx={8.86} ry={8.86} />
        <path
          className="st1"
          d="M230.21,1.42c4.11,0,7.44,3.33,7.44,7.44v53.15c0,4.11-3.33,7.44-7.44,7.44H8.75c-4.11,0-7.44-3.33-7.44-7.44V8.86C1.31,4.75,4.64,1.42,8.75,1.42h221.46M230.21,0H8.75C3.88,0-.11,3.99-.11,8.86v53.15c0,4.87,3.99,8.86,8.86,8.86h221.46c4.87,0,8.86-3.99,8.86-8.86V8.86C239.07,3.99,235.08,0,230.21,0h0Z"
        />
        <path
          className="st4"
          d="M120.61,38.53c-4.16,0-7.56,3.17-7.56,7.53s3.4,7.53,7.56,7.53,7.56-3.19,7.56-7.53-3.4-7.53-7.56-7.53ZM120.61,50.63c-2.29,0-4.25-1.88-4.25-4.57s1.97-4.57,4.25-4.57,4.25,1.86,4.25,4.57-1.97,4.57-4.25,4.57ZM104.1,38.53c-4.16,0-7.56,3.17-7.56,7.53s3.4,7.53,7.56,7.53,7.56-3.19,7.56-7.53-3.4-7.53-7.56-7.53ZM104.1,50.63c-2.29,0-4.25-1.88-4.25-4.57s1.97-4.57,4.25-4.57,4.25,1.86,4.25,4.57-1.97,4.57-4.25,4.57ZM84.47,40.85v3.19h7.65c-.23,1.81-.83,3.12-1.74,4.02-1.12,1.12-2.85,2.34-5.9,2.34-4.71,0-8.4-3.79-8.4-8.5s3.69-8.5,8.4-8.5c2.53,0,4.39.99,5.76,2.29l2.25-2.25c-1.91-1.82-4.45-3.22-8.03-3.22-6.45,0-11.87,5.24-11.87,11.71s5.42,11.71,11.87,11.71c3.49,0,6.11-1.13,8.17-3.28,2.11-2.11,2.76-5.08,2.76-7.48,0-.74-.05-1.44-.18-2h-10.75v-.02ZM164.75,43.33c-.62-1.68-2.53-4.8-6.45-4.8s-7.1,3.05-7.1,7.53c0,4.22,3.19,7.53,7.48,7.53,3.45,0,5.46-2.11,6.27-3.33l-2.57-1.72c-.85,1.26-2.02,2.09-3.7,2.09s-2.89-.78-3.65-2.29l10.08-4.16-.34-.85s-.02,0-.02,0ZM154.47,45.85c-.09-2.91,2.25-4.39,3.93-4.39,1.31,0,2.43.66,2.8,1.59l-6.73,2.8ZM146.29,53.15h3.31v-22.15h-3.31v22.15ZM140.86,40.22h-.11c-.74-.89-2.16-1.68-3.97-1.68-3.77,0-7.23,3.31-7.23,7.56s3.45,7.51,7.23,7.51c1.81,0,3.22-.8,3.97-1.72h.11v1.08c0,2.89-1.54,4.43-4.02,4.43-2.02,0-3.28-1.45-3.79-2.68l-2.89,1.2c.83,2,3.03,4.45,6.68,4.45,3.88,0,7.16-2.29,7.16-7.85v-13.54h-3.14s0,1.22,0,1.22ZM137.06,50.63c-2.29,0-4.2-1.91-4.2-4.54s1.91-4.59,4.2-4.59,4.02,1.95,4.02,4.59-1.77,4.54-4.02,4.54ZM180.27,31h-7.92v22.15h3.31v-8.4h4.62c3.67,0,7.26-2.66,7.26-6.87s-3.6-6.87-7.26-6.87h-.02ZM180.34,41.67h-4.69v-7.6h4.69c2.48,0,3.88,2.06,3.88,3.79s-1.4,3.79-3.88,3.79h0v.02ZM200.78,38.5c-2.39,0-4.87,1.06-5.9,3.38l2.94,1.22c.62-1.22,1.79-1.63,3.01-1.63,1.7,0,3.45,1.03,3.47,2.85v.23c-.6-.34-1.88-.85-3.45-.85-3.17,0-6.38,1.74-6.38,4.98,0,2.96,2.59,4.87,5.49,4.87,2.21,0,3.45-.99,4.22-2.16h.11v1.72h3.19v-8.49c0-3.93-2.94-6.13-6.73-6.13h.04ZM200.37,50.63c-1.08,0-2.59-.55-2.59-1.88,0-1.7,1.88-2.36,3.51-2.36,1.45,0,2.14.32,3.01.74-.25,2.06-2.02,3.51-3.93,3.51h0v-.02ZM219.12,38.98l-3.79,9.6h-.11l-3.93-9.6h-3.56l5.9,13.43-3.37,7.46h3.45l9.09-20.89s-3.69,0-3.69,0ZM189.35,53.15h3.31v-22.15h-3.31v22.15Z"
        />
        <g>
          <path
            className="st5"
            d="M36.6,34.41l-18.87,20.02h0c.58,2.18,2.57,3.77,4.93,3.77.94,0,1.82-.25,2.59-.71l.05-.04,21.22-12.24-9.94-10.82h.02v.02Z"
          />
          <path
            className="st3"
            d="M55.68,31h-.02l-9.16-5.33-10.33,9.19,10.36,10.36,9.12-5.26c1.59-.87,2.68-2.55,2.68-4.48s-1.06-3.61-2.66-4.46h0v-.02Z"
          />
          <path
            className="st0"
            d="M17.73,16.44c-.11.43-.18.85-.18,1.31v35.38c0,.46.05.89.18,1.31l19.51-19.51s-19.51-18.5-19.51-18.5Z"
          />
          <path
            className="st2"
            d="M36.74,35.43l9.76-9.76-21.21-12.3c-.76-.46-1.67-.73-2.64-.73-2.36,0-4.34,1.61-4.93,3.77h0l19.01,18.99h0v.02Z"
          />
        </g>
      </g>
      <g>
        <polygon
          className="st4"
          points="84.86 23.26 86.6 23.26 86.6 13.87 91.36 13.87 91.36 23.26 93.08 23.26 93.08 12.22 84.86 12.22 84.86 23.26"
        />
        <path
          className="st4"
          d="M103.71,12.76c-.87-.51-1.84-.76-2.91-.76s-2.04.25-2.91.76c-.87.51-1.56,1.2-2.06,2.09-.5.89-.74,1.84-.74,2.91s.25,2.04.74,2.91c.5.89,1.19,1.58,2.06,2.09s1.84.76,2.91.76,2.04-.25,2.91-.76c.87-.51,1.56-1.2,2.06-2.09s.74-1.86.74-2.91-.25-2.02-.76-2.91c-.5-.89-1.19-1.58-2.06-2.09h.02ZM104.24,19.88c-.35.62-.83,1.1-1.44,1.45s-1.28.53-2,.53-1.4-.18-2-.53-1.08-.83-1.44-1.45c-.35-.62-.53-1.33-.53-2.14s.18-1.51.53-2.14.83-1.1,1.44-1.45c.6-.35,1.28-.53,2-.53s1.4.18,2,.53,1.08.83,1.44,1.45.53,1.33.53,2.14-.18,1.51-.53,2.14Z"
        />
        <polygon
          className="st4"
          points="116.88 12.31 116.88 12.22 114.7 12.22 110.34 17.57 110.25 17.57 110.25 12.22 108.51 12.22 108.51 23.26 110.25 23.26 110.25 18.21 110.34 18.21 114.86 23.26 117.14 23.26 117.14 23.17 112.27 17.84 116.88 12.31"
        />
        <polygon
          className="st4"
          points="118.12 13.87 121.18 13.87 121.18 23.26 122.92 23.26 122.92 13.87 126 13.87 126 12.22 118.12 12.22 118.12 13.87"
        />
        <polygon
          className="st4"
          points="134.59 16.8 129.47 16.8 129.47 12.22 127.74 12.22 127.74 23.26 129.47 23.26 129.47 18.44 134.59 18.44 134.59 23.26 136.29 23.26 136.29 12.22 134.59 12.22 134.59 16.8"
        />
        <polygon
          className="st4"
          points="138.37 13.96 141.48 17.63 138.37 21.53 138.37 23.26 145.22 23.26 145.22 21.65 140.35 21.65 143.54 17.63 140.35 13.84 145.22 13.84 145.22 12.22 138.37 12.22 138.37 13.96"
        />
        <polygon
          className="st4"
          points="146.59 13.87 149.67 13.87 149.67 23.26 151.41 23.26 151.41 13.87 154.49 13.87 154.49 12.22 146.59 12.22 146.59 13.87"
        />
        <polygon
          className="st4"
          points="156.22 23.26 162.94 23.26 162.94 21.61 157.96 21.61 157.96 18.57 162.44 18.57 162.44 16.92 157.96 16.92 157.96 13.87 162.94 13.87 162.94 12.22 156.22 12.22 156.22 23.26"
        />
        <polygon
          className="st4"
          points="167.78 13.87 170.86 13.87 170.86 23.26 172.59 23.26 172.59 13.87 175.68 13.87 175.68 12.22 167.78 12.22 167.78 13.87"
        />
        <path
          className="st4"
          d="M185.14,12.76c-.87-.51-1.84-.76-2.91-.76s-2.04.25-2.91.76-1.56,1.2-2.06,2.09c-.5.89-.74,1.84-.74,2.91s.25,2.04.74,2.91c.5.89,1.19,1.58,2.06,2.09s1.84.76,2.91.76,2.04-.25,2.91-.76,1.56-1.2,2.06-2.09c.5-.89.74-1.86.74-2.91s-.25-2.02-.76-2.91c-.5-.89-1.19-1.58-2.06-2.09h.02ZM185.67,19.88c-.35.62-.83,1.1-1.44,1.45s-1.28.53-2,.53-1.4-.18-2-.53-1.08-.83-1.44-1.45c-.35-.62-.53-1.33-.53-2.14s.18-1.51.53-2.14.83-1.1,1.44-1.45c.6-.35,1.28-.53,2-.53s1.4.18,2,.53,1.08.83,1.44,1.45.53,1.33.53,2.14-.18,1.51-.53,2.14Z"
        />
        <polygon
          className="st4"
          points="192.99 13.96 196.1 17.63 192.99 21.53 192.99 23.26 199.84 23.26 199.84 21.65 194.97 21.65 198.16 17.63 194.97 13.84 199.84 13.84 199.84 12.22 192.99 12.22 192.99 13.96"
        />
        <polygon
          className="st4"
          points="201.21 13.87 204.31 13.87 204.31 23.26 206.03 23.26 206.03 13.87 209.11 13.87 209.11 12.22 201.21 12.22 201.21 13.87"
        />
        <path
          className="st4"
          d="M220.62,14.85c-.5-.89-1.19-1.58-2.06-2.09s-1.84-.76-2.91-.76-2.04.25-2.91.76-1.56,1.2-2.06,2.09c-.5.89-.74,1.84-.74,2.91s.25,2.04.74,2.91c.5.89,1.19,1.58,2.06,2.09s1.84.76,2.91.76,2.04-.25,2.91-.76,1.56-1.2,2.06-2.09c.5-.89.74-1.86.74-2.91s-.25-2.02-.76-2.91h.02ZM219.1,19.88c-.35.62-.83,1.1-1.44,1.45s-1.28.53-2,.53-1.4-.18-2-.53-1.08-.83-1.44-1.45c-.35-.62-.53-1.33-.53-2.14s.18-1.51.53-2.14.83-1.1,1.44-1.45c.6-.35,1.28-.53,2-.53s1.4.18,2,.53,1.08.83,1.44,1.45.53,1.33.53,2.14-.18,1.51-.53,2.14Z"
        />
        <path
          className="st4"
          d="M77.05,12.22l-4.15,11.04h1.91l1.01-2.82h4.45l.99,2.82h1.91l-4.15-11.04h-1.98ZM76.39,18.83l1.17-3.28.43-1.28h.09l.43,1.28,1.17,3.28h-3.3.02Z"
        />
      </g>
    </svg>
  );
};
